<div class="modal-header">
  <h4 class="modal-title">Referral Tree</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeEvent.emit()"></button>
</div>
<div class="modal-body">
  <div *ngIf="loading" class="text-center p-3">
    Loading...
  </div>
  <div *ngIf="!loading && data" style="min-height: 200px;">
    
    <ul class="tree-list">
      <!-- Parent 2 -->
      <li *ngIf="data.parent2" class="parent-node text-muted">
        Level 2 Parent: <a href="javascript:void(0)" (click)="selectPlayer(data.parent2.uuid)" class="text-decoration-none">{{ data.parent2.code }} - {{ data.parent2.name }}</a>
        <span class="badge bg-success ms-1" *ngIf="data.parent2.is_agent == 1">Agent {{ data.parent2.agent_rate | number:'1.0-3' }}%</span>
      </li>
      
      <!-- Parent 1 -->
      <li *ngIf="data.parent1" class="parent-node text-secondary" [ngStyle]="{'margin-left': data.parent2 ? '20px' : '0px'}">
        Level 1 Parent: <a href="javascript:void(0)" (click)="selectPlayer(data.parent1.uuid)" class="text-decoration-none">{{ data.parent1.code }} - {{ data.parent1.name }}</a>
        <span class="badge bg-success ms-1" *ngIf="data.parent1.is_agent == 1">Agent {{ data.parent1.agent_rate | number:'1.0-3' }}%</span>
      </li>

      <!-- Current Player -->
      <li *ngIf="data.player" class="current-node fw-bold" [ngStyle]="{'margin-left': data.parent1 ? (data.parent2 ? '40px' : '20px') : '0px'}">
        <div class="d-inline-flex align-items-center bg-primary text-white px-3 py-1 rounded shadow-sm my-1">
          <span class="fw-bold"><i class="fas fa-user-circle me-2 opacity-75"></i> {{ data.player.code }} - {{ data.player.name }}</span>
          <span class="badge bg-light text-primary ms-2" *ngIf="data.player.is_agent == 1">Agent {{ data.player.agent_rate | number:'1.0-3' }}%</span>
        </div>
        
        <ul class="children-list mt-2" style="list-style-type: none; padding-left: 20px;" *ngIf="data.children?.length > 0">
           <li *ngFor="let child of data.children" class="child-node mb-1 fw-normal">
             <i class="fas fa-level-up-alt fa-rotate-90 text-muted me-2"></i>
             <a href="javascript:void(0)" (click)="selectPlayer(child.uuid)" class="text-decoration-none">{{ child.code }} - {{ child.name }}</a>
             <span class="badge bg-success ms-1" *ngIf="child.is_agent == 1">Agent {{ child.agent_rate | number:'1.0-3' }}%</span>
             <small class="text-muted ms-2" *ngIf="child.total_referrals > 0">(Has {{child.total_referrals}} downlines)</small>
           </li>
        </ul>
        <div class="text-muted ms-3 mt-2 fw-normal" *ngIf="!data.children || data.children.length === 0">
          <small>No downlines</small>
        </div>
      </li>
    </ul>

  </div>
</div>
